import cssModule from "./index.module.scss"
import type { ChangeEvent } from "react"
import { ColorStyleProp } from "~/shared/ui/kit"
import { cx } from "classix"

export type RadioGroupProps = {
	name?: string
	items: ({
		value: string,
		label: string
	})[],
	value: string
	column?: boolean
	onChange: (value: string) => void
} & ColorStyleProp

export function RadioGroup({ name, items, value, onChange, colorStyle = "primary", column = false }: RadioGroupProps) {

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)

	return <div className={cx(cssModule.root, column && cssModule.column)}>
		{items.map(item => <label key={item.value}>
			<input checked={value === item.value}
				   className={cx(cssModule.input, `cs-${colorStyle}`)}
				   name={name}
				   value={item.value}
				   type="radio"
				   onChange={handleChange} />
			<span className={cssModule.label}>{item.label}</span>
		</label>)}
	</div>
}